const newSealType = {
  snackbar: "Your update is ready",
  name: "Seal  Type",
  save: "Save",
  cancel: "Cancel",
  area: "Seal Type",
  formTitle: "New Seal Type",
  confirm: "Are you sure you want to delete this item?",
  close: "Close",
  delete: "Delete"
};
export default newSealType;
